module.exports = __webpack_public_path__ + "img/color1.c9d92599.png";